import React from 'react';
import { Link } from 'gatsby';
import Button from '@mui/material/Button';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { NavigationDocumentDataBodyButtonsSliceItem } from '../../../../types.generated';

interface Props {
  buttons: NavigationDocumentDataBodyButtonsSliceItem[];
}

const NavigationButtons: React.FC<Props> = ({ buttons }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box
      sx={{
        textAlign: isDesktop ? 'center' : '',
      }}
    >
      {buttons?.map((button) => (
        !button.hide && (
          button.url_external.text ? (
            <Button
              key={button.button_id}
              size="small"
              href={button.url_external.text}
              fullWidth={isMobile}
              sx={{ marginBottom: isMobile ? 2 : 0, marginRight: isMobile ? 0 : 2 }}
              target="_blank"
              rel="noopener noreferrer"
              variant={button.variant.text}
            >
              {button.title.text}
            </Button>
          ) : (
            <Button
              key={button.button_id}
              size="small"
              component={Link}
              fullWidth={isMobile}
              sx={{ marginBottom: isMobile ? 2 : 0, marginRight: isMobile ? 0 : 2 }}
              to={button.url.text}
              variant={button.variant.text}
            >
              {button.title.text}
            </Button>
          )
        )
      ))}
    </Box>
  );
};

export default NavigationButtons;
